import React, { HTMLAttributes } from 'react'

import { P } from '@frame/ui-primitives/p'

import { cn } from '@frame/lib/utils/cn'

type Props = {
  items: string[]
  title?: string
} & HTMLAttributes<HTMLDivElement>

export function UnorderedList({ items, title, ...props }: Props) {
  return (
    <div {...props}>
      {title && <P className={cn('font-bold', props.className)}>{title}</P>}
      <ul className="list-disc pl-5">
        {items.map((item, index) => (
          <li key={index} className="text-moss-700">
            {item}
          </li>
        ))}
      </ul>
    </div>
  )
}
